import { api } from "./client";

export interface WorldBossStatus {
  enabled: boolean;
  is_active: boolean;
  event_id: string | null;
  boss_name: string;
  boss_level: number;
  boss_hp: number;
  boss_max_hp: number;
  boss_dead: boolean;
  seconds_until_start: number | null;
  seconds_remaining: number | null;
  my_total_damage: number;
  my_rank: number | null;
  window: { utc_start_hour: number; duration_minutes: number };
  energy_cost: number;
  death_cooldown_seconds: number;
  instant_revive_diamond_cost: number;
}

export interface WorldBossLeaderboardEntry {
  rank: number;
  user_id: number;
  display_name: string;
  hero_class: string;
  damage: number;
}

export interface WorldBossLeaderboard {
  hero_class: string;
  entries: WorldBossLeaderboardEntry[];
  my_rank: number | null;
  my_damage: number;
}

export interface WorldBossAttackResult {
  battle_id: number;
  damage_dealt: number;
  boss_hp_remaining: number;
  boss_max_hp: number;
  boss_killed: boolean;
  rewards: { gold: number; xp: number; diamonds: number; arcane_dust?: number; damage?: number };
  info_messages: string[];
  lucky_striker: string | null;
}

export const worldBossApi = {
  getStatus: () => api.get<WorldBossStatus>("/world-boss/status"),

  getLeaderboard: (heroClass: string = "ALL") =>
    api.get<WorldBossLeaderboard>(`/world-boss/leaderboard?class=${encodeURIComponent(heroClass)}`),

  presence: () => api.post<{ ok: boolean }>("/world-boss/presence"),

  startDeathCooldown: () =>
    api.post<{ death_cooldown_seconds: number }>("/world-boss/death-cooldown/start"),

  attack: (instantRevive = false) =>
    api.post<WorldBossAttackResult>(
      `/world-boss/attack${instantRevive ? "?instant_revive=true" : ""}`,
    ),
};
